import { createTokens } from 'tamagui'

export const spaceTokens = {
  0: 0,
  0.5: 2,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  11: 44,
  12: 48,
  14: 56,
  16: 64,
  20: 80,
  24: 96,
  25: 100,
  28: 112,
  29: 115,
  31: 125,
  32: 128,
  36: 144,
  40: 160,
  41: 165,
  44: 176,
  47: 190,
  48: 192,
  52: 208,
  54: 215,
  56: 224,
  60: 240,
  // component sizing tokens
  buttonPrimaryHeight: 48,
  buttonSecondaryHeight: 48,
  buttonTertiaryHeight: 33,
  strokeHairline: 0.33,
  true: 16,
}

export const radiusTokens = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  12: 48,
  24: 96,
  // component radius tokens
  buttonPrimaryRadius: 8,
  buttonSecondaryRadius: 8,
  buttonTertiaryRadius: 30,
  cardRadius: 24,
  full: 9999,
  true: 8,
}

export const zIndexTokens = {
  0: 0,
  1: 100,
  2: 200,
  3: 300,
  4: 400,
  5: 500,
  true: 100,
}

export const fontSizeTokens = {
  0: 10,
  1: 12,
  2: 14,
  3: 16,
  4: 18,
  5: 20,
  6: 24,
  7: 32,
  8: 40,
  9: 48,
  10: 56,
  entrataHeadline: 33,
  entrataBody: 17,
  entrataParagraph: 17,
  entrataTextLinkSmall: 13,
  entrataTextLinkLarge: 15,
}

export const tokens = createTokens({
  size: { ...spaceTokens, ...fontSizeTokens },
  space: spaceTokens,
  radius: radiusTokens,
  zIndex: zIndexTokens,
})


